import { MarkdownOutput } from '../types';
import yaml from 'yaml';
import { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles, Typography } from '@material-ui/core';
import { CodeSnippet } from '@backstage/core-components';
import ReactMarkdown, { Components } from 'react-markdown';

const useStyles = makeStyles({
  root: {
    padding: '2rem',
    marginBottom: '1rem',
  },
});

export interface MarkdownProps {
  markdown: string;
}
const components: Components = {
  code: p =>
    p.children.length > 0 ? (
      <CodeSnippet
        customStyle={{
          maxHeight: '20rem',
        }}
        text={String(p.children).replace(/\n+$/, '')}
        language={p.lang || 'text'}
        showCopyCodeButton
      />
    ) : null,
};
export function Markdown(props: MarkdownProps) {
  const { markdown } = props;
  const { root } = useStyles();
  const options: MarkdownOutput = useMemo(() => {
    try {
      return yaml.parseDocument(markdown).toJSON();
    } catch {
      return {
        title: 'Invalid config',
        content: `The provided config is invalid`,
      } as MarkdownOutput;
    }
  }, [markdown]);
  return (
    <Paper className={root}>
      <Typography variant="h4">{options.title}</Typography>
      <ReactMarkdown components={components} children={options.content} />
    </Paper>
  );
}
